import { useMemo } from "react"
import { BigNumber } from "ethers"
import { useUserFerroBoost } from "src/state/xFer/hooks"
import { BIG_ZERO } from "src/constants/bigNumber"

export default function useTotalVault(): BigNumber {
  const { boostData } = useUserFerroBoost()
  const { stakes } = boostData
  const totalVault = useMemo(() => {
    return stakes
      .filter((x) => x.active)
      .map((x) => x.amount)
      .reduce((a, b) => a.add(b), BIG_ZERO)
  }, [stakes])
  return totalVault
}
